import { createSlice } from '@reduxjs/toolkit';

export const tagSliceKey = 'tagState';

const initialState = {
  allTags: [],
  isLoading: false,
  error: null
};

const { actions, reducer } = createSlice({
  name: tagSliceKey,
  initialState,
  reducers: {
    // Acciones para solicitar tags
    fetchTagsRequested(state) {
      state.isLoading = true;
      state.error = null;
    },
    fetchTagsSucceeded(state, { payload }) {
      state.allTags = payload;
      state.isLoading = false;
      state.error = null;
    },
    fetchTagsFailed(state, { payload }) {
      state.isLoading = false;
      state.error = payload;
    },

    // Acciones para actualizar tags
    addTag(state, { payload }) {
      state.allTags.push(payload);
    },
    updateTag(state, { payload }) {
      const index = state.allTags.findIndex((tag) => tag.id === payload.id);
      if (index !== -1) {
        state.allTags[index] = payload;
      }
    },
    removeTag(state, { payload }) {
      state.allTags = state.allTags.filter((tag) => tag.id !== payload);
    },

    // Acción para limpiar los tags
    clearTags(state) {
      state.allTags = [];
    }
  }
});

// Selectores
const baseSelector = (state) => state[tagSliceKey];

export function getAllTagsSelector(state) {
  return baseSelector(state).allTags;
}

export function getTagByIdSelector(state, tagId) {
  return baseSelector(state).allTags.find((tag) => tag.id === tagId);
}

export function getTagsLoadingSelector(state) {
  return baseSelector(state).isLoading;
}

export function getTagsErrorSelector(state) {
  return baseSelector(state).error;
}

// Exportaciones
export const tagReducer = reducer;
export const {
  fetchTagsRequested,
  fetchTagsSucceeded,
  fetchTagsFailed,
  addTag,
  updateTag,
  removeTag,
  clearTags
} = actions;
